// HP-9290, Dimension builder fall back to old version
export const useDimensionWorkflow = () => {
  return false;
};
